var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import Vue from "vue";
import gql from "graphql-tag";
export default Vue.extend({
    props: {
        property: {
            type: Object,
            required: true,
        },
    },
    fragments: {
        property: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      fragment MainDetailIcons_property on PropertyListing {\n        id\n        numberOfBedrooms\n        numberOfBathrooms\n        under18sApproved\n        roomTypes {\n          id\n        }\n      }\n    "], ["\n      fragment MainDetailIcons_property on PropertyListing {\n        id\n        numberOfBedrooms\n        numberOfBathrooms\n        under18sApproved\n        roomTypes {\n          id\n        }\n      }\n    "]))),
    },
});
var templateObject_1;
